import { useFormikContext } from "formik";
import { useState } from "react";
import { metaobject, sectionSettings, configuratorOptions } from "../../Helpers/WindowHelpers";
import HeaderStepDesktop from "./HeaderStepDesktop";
import FormikValueList from "./FormikValueList";
import MobileStepDisplay from "./MobileStepDisplay";
import HeaderStepMobile from "./HeaderStepMobile";
import StartOverButton from "./StartOverButton";

interface HeaderDisplayInterface {
    stepNumber?: number,
    setStep: (step: number) => void,
    closeConfigurator: () => void
}

const HeaderDisplay = ({ stepNumber, setStep, closeConfigurator }: HeaderDisplayInterface) => {
    const context = useFormikContext<any>();
    const [open, setOpen] = useState(false);

    const updateStep = (step: number) => {
        setStep(step);
    }

    const findOption = (option: string) => {
        return configuratorOptions.find((item) => item.value == option);
    }

    let stepLists = [
        [findOption('model'), findOption('brand'), findOption('cover')],
        [findOption('shape'), findOption('dimension_a'), findOption('dimension_b'), findOption('dimension_c'), findOption('dimension_d'), findOption('oversize_fee'), findOption('fold_direction'), findOption('strap_location'), findOption('skirt_length')],
        [findOption('color'), findOption('handle_option'), findOption('additional_handle_options')],
        [findOption('upgrade_and_accessory_package'), findOption('upgrades'), findOption('accessories')]
    ];

    if (metaobject.rolling_covers) {
        stepLists[1] = [findOption('shape'), findOption('dimension_a'), findOption('dimension_b'), findOption('dimension_c'), findOption('dimension_d'), findOption('oversize_fee')];
        stepLists[2] = [findOption('color'), findOption('strap_length'), findOption('skirt_length')];
    }

    // Add an empty step if CAD step is enabled
    if(metaobject.enable_cad_step) stepLists.push([]);

    return (
        <div className="configurator-nav" role="toolbar">
            {stepLists.map((list, index) =>
                <HeaderStepDesktop
                    key={index}
                    title={sectionSettings[`step_${index + 1}_label`]}
                    stepNumber={stepNumber}
                    stepValue={index + 1}
                    setStep={() => index == 0 ? closeConfigurator() : updateStep(index - 1)}
                    classes="desktop"
                >
                    <FormikValueList items={list} context={context} classes={"configurator-steps__reveal"} excludedTitles={['oversize_fee']} />
                </HeaderStepDesktop>
            )}
            <MobileStepDisplay
                open={open}
                setOpen={setOpen}
                classes="ml-auto"
            >
                <StartOverButton classes="absolute" />
                {stepLists.map((list, index) =>
                    <HeaderStepMobile
                        key={index}
                        title={sectionSettings[`step_${index + 1}_label`]}
                        stepNumber={stepNumber}
                        stepValue={index + 1}
                        setStep={() => index == 0 ? closeConfigurator() : updateStep(index - 1)}
                    >
                        <FormikValueList items={list} context={context} classes={"configurator-steps__reveal"} excludedTitles={['oversize_fee']} />
                    </HeaderStepMobile>
                )}
            </MobileStepDisplay>
        </div>
    );
}

export default HeaderDisplay;